import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const LevelTest: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      {/* Page Header */}
      <div className="relative text-white py-12 sm:py-16 md:py-20 lg:py-24 mt-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=1920&h=600&fit=crop&q=80"
            alt="Level Test"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/50"></div>
        </div>

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <p className="text-gray-200 mb-2 sm:mb-3 text-xs sm:text-sm font-medium tracking-wider">LMS (학습 플랫폼)</p>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-3 sm:mb-4">레벨테스트 (Assessment Hub)</h1>
          <div className="w-16 sm:w-20 h-1 bg-white/70"></div>
        </div>
      </div>

      {/* Content Section */}
      <div className="flex-1 py-8 sm:py-10 md:py-12 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">

          {/* 유.초등 레벨테스트 섹션 */}
          <div id="elementary" className="bg-white rounded-lg shadow-sm p-6 sm:p-8 mb-8 scroll-mt-32">
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-6">유.초등 레벨테스트</h2>

            {/* 이미지 */}
            <div className="mb-6">
              <img
                src="/lv-1.png"
                alt="유.초등 레벨테스트"
                className="w-full max-w-2xl rounded-lg"
              />
            </div>

            {/* 링크 버튼 */}
            <div>
              <a
                href="https://www.rhdiscovery.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 transition-colors"
              >
                레벨테스트 바로가기
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>
            </div>
          </div>

          {/* 초4+ 레벨테스트 섹션 */}
          <div id="grade4plus" className="bg-white rounded-lg shadow-sm p-6 sm:p-8 mb-8 scroll-mt-32">
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-6">초4+ 레벨테스트</h2>

            {/* 이미지 */}
            <div className="mb-6">
              <img
                src="/lv-2.png"
                alt="초4+ 레벨테스트"
                className="w-full max-w-2xl rounded-lg"
              />
            </div>

            {/* 링크 버튼 */}
            <div>
              <a
                href="https://www.rhelevate.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 transition-colors"
              >
                레벨테스트 바로가기
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>
            </div>
          </div>

          {/* 중.고등 ELTIS 테스트 섹션 */}
          <div id="eltis" className="bg-white rounded-lg shadow-sm p-6 sm:p-8 mb-8 scroll-mt-32">
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-6">중. 고등 ELTIS 테스트</h2>

            {/* 이미지 */}
            <div className="mb-6">
              <img
                src="/lv-3.png"
                alt="중.고등 ELTIS 테스트"
                className="w-full max-w-2xl rounded-lg"
              />
            </div>

            {/* 링크 버튼 */}
            <div>
              <a
                href="https://www.myeltis.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 transition-colors"
              >
                레벨테스트 바로가기
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>
            </div>
          </div>

        </div>
      </div>

      <Footer />
    </div>
  );
};

export default LevelTest;
